import { useEffect, useState } from 'react';
import { fetchAllowedDeleteUserEmails } from 'constants/delete-user.constants';

export const useAllowedDeleteUserEmails = () => {
  const [allowedEmails, setAllowedEmails] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadAllowedEmails = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const emails = await fetchAllowedDeleteUserEmails();
        setAllowedEmails(emails);
      } catch (err) {
        setError('Error al cargar los emails permitidos');
        console.error('Error loading allowed emails:', err);
      } finally {
        setIsLoading(false);
      }
    };

    loadAllowedEmails();
  }, []);

  return {
    allowedEmails,
    isLoading,
    error,
  };
};
